import React, { FunctionComponent, useEffect, useState } from "react";
import { Form } from "react-bootstrap";

import { getActiveSubscription } from "../../actions/subscription/getActiveSubscription";
import { db } from "../../lib/firebase";

export const PlusToggle: FunctionComponent<{ userId: string }> = ({ userId }) => {
  const [checked, setChecked] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const sub = await getActiveSubscription(userId);
        if (!isMounted) return;
        setChecked(
          !!(sub && sub.role === "Spielgruppe Plus" && (sub.status === "active" || sub.status === "trialing"))
        );
      } catch (e) {
        console.error("Failed to load subscription", e);
        if (isMounted) setError("Fehler beim Laden");
      } finally {
        if (isMounted) setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [userId]);

  const onChange = async (e: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
    const next = e.target.checked;
    setChecked(next);
    setSaving(true);
    setError(null);
    try {
      const ref = db.collection("users").doc(userId).collection("manualSubscriptions").doc("spielgruppePlus");
      if (next) {
        await ref.set({ role: "Spielgruppe Plus", status: "active" }, { merge: true });
      } else {
        await ref.set({ status: "inactive" }, { merge: true });
      }
    } catch (err) {
      console.error("Error while saving Spielgruppe Plus.", err);
      setChecked(!next); // rollback
      setError("Speichern fehlgeschlagen");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Form.Check
      type="checkbox"
      id={`plus-${userId}`}
      label={loading ? "Laden..." : "Plus"}
      checked={checked}
      onChange={onChange}
      disabled={loading || saving}
      isInvalid={!!error}
      feedback={error ?? undefined}
    />
  );
};
